import { Controller } from "@hotwired/stimulus"

// Toggles between preview text and full disclaimer text.
// Targets: preview (the truncated view), full (the expanded view).
export default class extends Controller {
  static targets = ["preview", "full"]

  expand(event) {
    event.preventDefault()
    this.previewTarget.classList.add("hidden")
    this.fullTarget.classList.remove("hidden")
  }

  collapse(event) {
    event.preventDefault()
    this.fullTarget.classList.add("hidden")
    this.previewTarget.classList.remove("hidden")
  }
}
